import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { CogIcon } from '@rsos/assets/icons';
import { Box, LinkComponent } from '@rsos/components/capstone/base';
import { CardTitle } from '@rsos/components/capstone/base/Card';
import { requestSAML } from '@rsos/sinatra';
import normalizeError from '@rsos/sinatra/src/utils/normalizeError';
import { notifyError } from '@rsos/utils/toastUtils';
import Tag from '../Tag';
import { RoleAvatarColorCircle, BasePrimaryText } from '../common.styles';
import {
  DataSourceCardContainer,
  StyledCheckbox,
  CardBodyContainer,
  CardFooterContiner,
  DataSourceDescription,
  RolesDisplayDeleteContainer,
  StyledButton,
} from './DataSourceCard.styles';
import RemoveDataSourceModal from './RemoveDataSource';
import { externalLinks } from './externalLinks';

const DataSourceCard = props => {
  const { dataSource, handleCheckbox, arrayHelpers, values } = props;
  const [isRemoveDataSourceModalOpened, setIsRemoveDataSourceModalOpened] =
    useState(false);
  const openRemoveDataSourceModal = () => {
    setIsRemoveDataSourceModalOpened(true);
  };
  const closeRemoveDataSourceModal = () => {
    setIsRemoveDataSourceModalOpened(false);
  };
  const dispatch = useDispatch();

  const handleSAMLRequest = () => {
    const service = 'support';

    dispatch(requestSAML(service)).catch(action => {
      const { error } = action;
      if (!error.response) {
        const errMsg = (
          <div>
            An error occurred. Please try again and{' '}
            <a href="mailto:support@rapidsos.com">contact support</a> if the
            error repeats.
          </div>
        );
        notifyError({ message: errMsg() });
      } else {
        const { message } = normalizeError(error);
        const errMsg = () => {
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: message,
              }}
            ></div>
          );
        };
        notifyError({ message: errMsg() });
      }
    });
  };
  const handleExternalLink = url => {
    window.open(url, '_blank', 'noopener noreferrer');
  };

  return (
    <DataSourceCardContainer width="100%" height={190}>
      <CardBodyContainer>
        <Box horizontal justify="space-between" align="center">
          <CardTitle noMargin fontWeight="regular">
            <BasePrimaryText>{dataSource.display_name}</BasePrimaryText>
          </CardTitle>
          <StyledCheckbox
            type="checkbox"
            data-name={dataSource.name}
            name={dataSource.name}
            value={dataSource.name}
            disabled={dataSource.isDisabled}
            checked={
              values.dataSources.find(r => r === dataSource.name) || false
            }
            onChange={e =>
              handleCheckbox(
                e,
                dataSource.name,
                values.dataSources,
                arrayHelpers,
              )
            }
          />
        </Box>
        {dataSource.is_new && (
          <Box my="9px">
            <Tag type="new" />
          </Box>
        )}
        <DataSourceDescription>
          {dataSource.whitelisting_required && (
            <LinkComponent type="primary" onClick={handleSAMLRequest} noPadding>
              URL whitelisting required.{' '}
            </LinkComponent>
          )}
          {dataSource.description}
          {externalLinks[dataSource.name] && (
            <>
              {' '}
              <LinkComponent
                type="primary"
                onClick={() =>
                  handleExternalLink(externalLinks[dataSource.name].url)
                }
                noPadding
              >
                {externalLinks[dataSource.name].title}
              </LinkComponent>
            </>
          )}
        </DataSourceDescription>
      </CardBodyContainer>
      <CardFooterContiner>
        {dataSource.roles.length > 0 && (
          <RolesDisplayDeleteContainer>
            <Box horizontal flow={5} align="center">
              {dataSource.roles.map(r => (
                <RoleAvatarColorCircle bg={r.avatar_bg_color} key={r.id} />
              ))}
            </Box>
            <StyledButton
              btnType="invisible"
              size="xsmall"
              noMargin
              type="button"
              onClick={openRemoveDataSourceModal}
            >
              <CogIcon width={14} height={16} />
            </StyledButton>
          </RolesDisplayDeleteContainer>
        )}
      </CardFooterContiner>
      <RemoveDataSourceModal
        isOpened={isRemoveDataSourceModalOpened}
        onClose={closeRemoveDataSourceModal}
        dataSource={dataSource}
      />
    </DataSourceCardContainer>
  );
};

export default DataSourceCard;
